export const WISHLIST_TABS = {
  OFFERS: {
    id: 'terms',
    title: 'Termos',
    iconName: 'description',
  },
  COUPONS: {
    id: 'coupons',
    title: 'Cupons',
    iconName: 'coupon',
  },
  PRODUCTS: {
    id: 'products',
    title: 'Produtos',
    iconName: 'shopping-cart',
  },
};
